import { listAnatomy as e } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as t, defineStyle as i } from "@chakra-ui/styled-system";
const { defineMultiStyleConfig: n, definePartsStyle: o } = t(e.keys), l = i({
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}), s = o({
  icon: l
}), a = n({
  baseStyle: s
});
export {
  a as listTheme
};
